<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">
      {{ $t("viewSettings.goods_export.export_to_ozon_via_seller_api") }}
    </h3>
    <v-card elevation="0" class="pa-3">
      <v-btn
        @click="
          isVisibleOzonSellerApiParametersForm =
            !isVisibleOzonSellerApiParametersForm
        "
        :disabled="isExportingInProcess"
        class="mr-2"
        color="primary"
        elevation="0"
      >
        <v-icon small> fa-cog </v-icon>
        {{ $t("viewSettings.goods_export.ozon_seller_api_parameters") }}
      </v-btn>
      <v-btn
        :disabled="isExportingInProcess"
        :loading="isExportingInProcess"
        @click="exportToOzonViaOzonSellerApi"
        color="success"
        elevation="0"
      >
        {{ $t("common.export") }}
      </v-btn>
    </v-card>
    <h3 class="pt-0 mt-0 pb-0">
      {{ $t("viewSettings.goods_export.uploading") }}
    </h3>
    <v-data-table
      :headers="[
        {
          text: this.$t('common.created_at'),
          value: 'created_at',
          sortable: true,
        },
        {
          text: this.$t('viewSettings.goods_export.error_message'),
          value: 'error_message',
          sortable: false,
        },
        {
          text: this.$t('viewSettings.goods_export.get_task_status'),
          value: 'ozon_task_id',
          sortable: false,
          align: 'center',
        },
      ]"
      :items="ozonTasks"
      elevation="0"
      :loading="isExportingInProcess || !isFetchedOzonTasks"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | moment("DD.MM.YYYY") }}
        <br/>
        {{ item.created_at | moment("HH:mm") }}
      </template>
      <template v-slot:item.ozon_task_id="{ item }">
        <span v-if="item.ozon_task_id">
          <v-btn fab small elevation="0" @click="showTaskInfo(item.ozon_task_id)">
            <v-icon color="primary" small> fa-info-circle </v-icon>
          </v-btn>
        </span>
        <span v-else>
          <v-icon color="danger" small> fa-times </v-icon>
        </span>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    <ozon-seller-api-task-import-info
        :task_id="windowOzonSellerApiTaskImportInfo.task_id"
        :show="windowOzonSellerApiTaskImportInfo.is_visible"
        @hide="windowOzonSellerApiTaskImportInfo.is_visible = false"/>
    <ozon-seller-api-parameters-form
      :show="isVisibleOzonSellerApiParametersForm"
      @hide="isVisibleOzonSellerApiParametersForm = false"
    />
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import OzonSellerApiParametersForm from "@/components/storage/OzonSellerApiParametersForm";
import OzonSellerApiTaskImportInfo from "@/components/storage/OzonSellerApiTaskImportInfo";

export default {
  name: "GoodsExportFormOzonSellerApi",
  components: {OzonSellerApiTaskImportInfo, OzonSellerApiParametersForm },
  data: () => ({
    windowOzonSellerApiTaskImportInfo:{
      is_visible: false,
      task_id: null
    },
    isVisibleOzonSellerApiParametersForm: false,
  }),
  watch: {},
  mounted() {
    this.$store.dispatch("ozon_seller_api/getOzonTasks");
  },
  computed: {
    ...mapFields("ozon_seller_api", [
      "ozonTasks",
      "isFetchedOzonTasks",
      "categoryAttributeWithValues",
      "isFetchedCategoryAttributes",
      "isExportingInProcess",
    ]),
  },
  methods: {
    showTaskInfo(taskId){
      this.windowOzonSellerApiTaskImportInfo.is_visible = true;
      this.windowOzonSellerApiTaskImportInfo.task_id = taskId;
    },
    exportToOzonViaOzonSellerApi() {
      this.$store.dispatch("ozon_seller_api/startExport");
    },
  },
};
</script>

<style scoped></style>
